import useSuspenseBaseFetch from "../../../internal/revamp/fetch/useSuspenseBaseFetch";
/**
 * @see https://sail.stripe.me/data/api/unstable_useSuspenseJsonFetch
 */ export default function useSuspenseJsonFetch(/**
   * The URL of the resource to be fetched.
   */ url, /**
   * The options to pass to the fetch.
   */ options = {}) {
    return useSuspenseBaseFetch(url, options, 'json');
}

//# sourceMappingURL=useSuspenseJsonFetch.js.map